import { React, useState } from 'react';
import ArtistCard from './ArtistCard';
const { getChart } = require('billboard-top-100');

export default function MyCarouselBody(props) {
  // const [artists, setArtists] = useState([]);
  // getChart('artist-100', (err, chart) => {
  //   if (err) console.log('Error big dawg');
  //   let res = [];
  //   for (let i = 0; i < 8; i++) {
  //     res.push(chart['songs'][i]['artist']);
  //   }
  //   console.log(res);
  //   setArtists(res);
  // });
  // const getCarouselArtists = async () => {
  //   getChart('artist-100', (err, chart) => {
  //     if (err) console.log('Error big dawg');
  //     let res = [];
  //     for (let i = 0; i < 8; i++) {
  //       res.push(chart['songs'][i]['artist']);
  //     }
  //     console.log(res);
  //     return res;
  //   });
  // };
  // const artists = await getCarouselArtists();
  const artists = {
    'The Weeknd':
      'https://images.genius.com/1bab7f9dbd1216febc16d73ae4da9bd0.1000x1000x1.jpg',
    'Kanye West':
      'https://images.genius.com/ceccff1664c8a331b9fe2143381b6df7.639x639x1.jpg',
    'Michael Jackson':
      'https://images.genius.com/f3b36efb63495f1fefe130d8c68cf0d8.800x800x1.jpg',
    'Charlie Puth':
      'https://images.genius.com/39c83be0d9b032abe95cc0654fe12e23.400x400x1.jpg',
    'Bruno Mars':
      'https://images.genius.com/edca1a867127a07d29f959070b1a2a5f.838x838x1.png',
    Beyonce:
      'https://images.genius.com/bf8aba171fcaa75b7137cbb73c5116ea.637x637x1.jpg',
    'Nicki Minaj':
      'https://images.genius.com/8ae5a5e5e030cb67814165bd038af48f.1000x1000x1.jpg',
    'Chris Brown':
      'https://images.genius.com/ec94d46d35fc8ee8b33a78df6849b7f5.512x512x1.png',
    Drake:
      'https://images.genius.com/c6b5142a09ff5bd361d0f42a55692edc.1000x1000x1.jpg',
    'Taylor Swift':
      'https://images.genius.com/3c1f124fcbbc2857a95e513fb34cc5a8.400x400x1.jpg',
    Rihanna:
      'https://images.genius.com/a23400b7447be0fb91c3c4c839c6efe7.442x442x1.jpg',
    'Elvis Presley':
      'https://images.genius.com/ef67deb0af3155a3dd05458c32f6c9f2.736x860x1.jpg',
  };
  return (
    <div>
      <p>or tap one of the artists below to view hot 100 No. 1 Records</p>
      <div className="myCarousel">
        {Object.keys(artists).map((artist) => {
          return (
            <div className="cardContainer">
              <ArtistCard
                artist={artist}
                imageURL={artists[artist]}
                handleSelectChange={props.handleSelectChange}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
